import React from "react";

const SolutionIntroSection = () => {
  return (
    <section className="px-4 md:px-16 py-12 text-center bg-white">
      <h2 className="text-lg md:text-2xl font-light font-outfitRegular">
        Your{" "}
        <span className="font-outfitSemiBold ">All-In-One Solution</span>{" "}
        For{" "}
        <span className="font-outfitSemiBold ">Smart Coaching</span> &{" "}
        <span className="font-outfitSemiBold">Real Exam Experience</span>
      </h2>

      <p className="mt-6 max-w-4xl mx-auto text-sm md:text-base leading-relaxed font-outfitRegular">
        Edupro Hub Offers A Powerful Suite Of Tools To Help Coaching Institutes{" "}
        <strong>Digitize, Organize, And Scale</strong> — While Giving Students
        The{" "}
        <strong>Most Realistic And Stress-Free Exam Preparation</strong>{" "}
        Experience. Whether You're Running{" "}
        <strong>A Single Center</strong> Or Expanding Across Multiple Cities,
        Our Platform Is Built To Support Your Growth And Deliver Real Results.
      </p>
    </section>
  );
};

export default SolutionIntroSection;
